var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Telegram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3844 19.7791C18.7064 20.0071 19.1214 20.0641 19.4914 19.9241C19.8614 19.7831 20.1334 19.4671 20.2154 19.0841C21.0844 15.0001 23.1924 4.66315 23.9834 0.948148C24.0434 0.668148 23.9434 0.377148 23.7234 0.190148C23.5034 0.00314829 23.1984 -0.0508518 22.9264 0.0501482C18.7334 1.60215 5.8204 6.44715 0.542398 8.40015C0.207398 8.52415 -0.0106021 8.84615 0.000397854 9.19915C0.0123979 9.55315 0.250398 9.86015 0.593398 9.96315C2.9604 10.6711 6.0674 11.6561 6.0674 11.6561C6.0674 11.6561 7.5194 16.0411 8.2764 18.2711C8.3714 18.5511 8.5904 18.7711 8.8794 18.8471C9.1674 18.9221 9.4754 18.8431 9.6904 18.6401C10.9064 17.4921 12.7864 15.7171 12.7864 15.7171C12.7864 15.7171 16.3584 18.3361 18.3844 19.7791V19.7791ZM7.3744 11.1021L9.0534 16.6401L9.4264 13.1331C9.4264 13.1331 15.9134 7.28215 19.6114 3.94715C19.7194 3.84915 19.7344 3.68515 19.6444 3.57015C19.5554 3.45515 19.3914 3.42815 19.2684 3.50615C14.9824 6.24315 7.3744 11.1021 7.3744 11.1021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bce925d0143e85864fe50e24b8f6b419.svg";
export { ForwardRef as ReactComponent };